"use strict";

var _ = require("underscore");

module.exports.currencyMask = function currencyMask(value) {
  return applyCurrencyMask(value);
};

function applyCurrencyMask(value) {
  if (value != null) {
    value = removeLeadingZeroes(value);
    var digits = breakDigitsIntoArray(value);
    digits = addLeadingZeros(digits);
    digits = addCharacterInPosition(digits, ",", 2);
    value = digits.join("");
    value = formatLongNumbers(value);
  }
  return value;
}

function removeLeadingZeroes(value) {
  return value.replace(/^0*/g, "");
}

function breakDigitsIntoArray(value) {
  return value.match(/\d/g) || ["0"];
}

function addLeadingZeros(digits) {
  var leadingZerosToFillDigits = [];
  if (digits.length === 1) {
    leadingZerosToFillDigits = ["0", "0"];
  } else if (digits.length === 2) {
    leadingZerosToFillDigits = ["0"];
  }

  return leadingZerosToFillDigits.concat(digits);
}

function addCharacterInPosition(digits, character, position) {
  var insertPosition = digits.length - position;

  var leftSide = digits.slice(0, insertPosition);
  var rightSide = digits.slice(insertPosition);

  return leftSide.concat(character, rightSide);
}

module.exports.formatLongNumbers = formatLongNumbers;

var THOUSAND_MIN_LENGTH = 6;
function formatLongNumbers(value) {
  if (value) {
    var isLongNumber = value.length > THOUSAND_MIN_LENGTH;
    if (isLongNumber) {
      var separatorsQuantity = thousandsQuantity(value);
      return addThousandSeparator(separatorsQuantity, value);
    }
  }
  return value;
};

function thousandsQuantity(value) {
    //Ignore Decimals and comma for calculations.
    var integerPart = removeDecimals(value, ",");

    //do not add first separator on number with length which is a multiples of 3
    var skipFirstSeparator = (integerPart.length % 3 === 0);
    var separatorsQuantity = Math.floor(integerPart.length / 3);

    if (skipFirstSeparator) {
      separatorsQuantity = separatorsQuantity - 1;
    }

    return separatorsQuantity;
}

function addThousandSeparator(separatorsQuantity, value) {
    var digits = value.split("");

    var position = THOUSAND_MIN_LENGTH;
    _(separatorsQuantity).times(function() {
      digits = addCharacterInPosition(digits, ".", position);
      position = position + 4; //3 characters for thousand and one for comma
    });

    return digits.join("");
}

function removeDecimals(value, separator) {
  var integerNumber = value;
  var numberParts = value.split(separator);
  if (numberParts.length > 1) {
    integerNumber = numberParts[0];
  }
  return integerNumber;
}

// format a string "1.234,50" to "1234.50"
module.exports.valueToAPIFormat = function valueToAPIFormat(value) {
  if (value) {
    value = removeThousandsSeparator(value); // "1234,50"
    var splittedValue = splitInComma(value); // ["1234", "50"]
    splittedValue = addDecimals(splittedValue); // ["1234", "50"]
    value = joinUsingDot(splittedValue); // "1234.50"
  }

  return value;
};

function removeThousandsSeparator(value) {
  return value.replace(/\./g, "");
}

function splitInComma(value) {
  return value.split(",");
}

function addDecimals(splittedValue) {
  var decimalPart = splittedValue[1];

  if (decimalPart === undefined || decimalPart.length === 0) {
    decimalPart = "00";
  } else if (decimalPart.length === 1) {
    decimalPart = decimalPart + "0";
  } else if (decimalPart.length > 2) {
    decimalPart = decimalPart.substring(0, 2);
  }

  return [splittedValue[0], decimalPart];
}

function joinUsingDot(splittedValue) {
  return splittedValue.join(".");
}

// format a number "1234.599" (or 1234.599) to a string "1.234,59"
module.exports.valueToViewFormat = valueToViewFormat;
function valueToViewFormat(value) {
  if (value) {
    var valueInCents = getValueInCents(value); // 123459.9
    var valueAsString = getValueAsString(valueInCents); // "123459.9"
    var valueWithoutDecimals = removeDecimals(valueAsString, "."); // "123459"
    value = applyCurrencyMask(valueWithoutDecimals); // 1.234,59
  }

  return value;
};

function getValueInCents(value) {
  return +((value * 100).toFixed(3));
}

function getValueAsString(value) {
  return value + "";
}

//format a number 15 to 15 and 15,00 to 15,50
module.exports.formatInteger = function formatInteger(value) {
  if (value) {
    return value.toString().replace(",00", "");
  }
  return "0";
};

//Made to work with InputText React component when working with currency
//(app/shared/components/InputText/input-text)
module.exports.calculateNewCaretPosition = function calculateNewCaretPosition(prevProps, newProps, caretPosition) {
  var newCaretPosition;

  if (valueChanged(prevProps.value, newProps.value)) {
    var oldLength = prevProps.value.length;
    var newLength = newProps.value.length;
    //Coeficient is used when new character is inserted or removed
    var coeficient;
    //For currency mask, default length is always 4 characters ("0,00"),
    //so backspaces/delete and insertions behave just normal, otherwise, caret should
    //move one character further or back depending if character is inserted or removed.
    if (newLength != 4) {
      coeficient = (newLength >= oldLength ? -1 : 1);
    } else {
      coeficient = (greaterNewValue(prevProps.value, newProps.value) ? -1 : 1);
    }
    newCaretPosition = Math.max(0, newLength - oldLength + caretPosition + coeficient);
  } else {
    newCaretPosition = caretPosition;
  }

  return newCaretPosition;
};

function valueChanged(prevValue, newValue) {
  return (newValue &&
      prevValue &&
      (newValue !== prevValue));
}

function greaterNewValue(prevValue, newValue) {
  var prevInt = parseFloat(prevValue.replace(",", "."));
  var newInt = parseFloat(newValue.replace(",", "."));

  return (newInt > prevInt);
}

module.exports.formatCentsToAbbreviatedCurrency = function(cents) {
  const value = cents / 100;
  const units = ["", "MIL", "MI", "BI"];

  const tier = Math.min(Math.log10(value) / 3 | 0, units.length);
  const scale = Math.pow(10, tier * 3);

  const scaled = value / scale;

  return "R$ " + scaled.toFixed(1) + " " + units[tier];
};

module.exports.formatCentsToCurrency = function(cents) {
  return (cents / 100).toLocaleString("pt-br", { style: "currency", currency: "BRL" });
};



// WEBPACK FOOTER //
// ./app/util/formatter/currency.js